module.exports = __webpack_public_path__ + "img/JourneyBinderConnect.51cd1299.png";